module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/shape-5-d4bf939195af81bdb7eb350e0cf51b47.png";